export const REGEXP = {
  URL: {
    regExp:
      '^((https)|(http)|(sftp)|(ftp))(\\:)(\\/\\/)?([\\w-]{1,32}\\.[\\w-]{1,32})[^\\s@]*$',
    message: 'validation.url',
  },
  EMAIL: {
    regExp:
      '^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$',
    message: 'validation.email',
  },
  PHONE: {
    regExp: '^[0-9\\+\\(\\)\\s\\-]{7,25}$',
    message: 'validation.phone',
  },
  TELEGRAM: {
    regExp:
      '.*\\B@(?=\\w{5,64}\\b)[a-zA-Z0-9]+(?:_[a-zA-Z0-9]+)*.*|^\\+[0-9]{9,15}$',
    message: 'validation.telegram',
  },
  NUMBERS_ONLY: {
    regExp: '^[0-9]*$',
    message: 'validation.numbersOnly',
  }
};

export const SPACES_REGEXP = /\s+/g;